import React, {Component} from 'react';
import {UserContext} from "../../../core/UserContext";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import {Drawer, Checkbox, FormControlLabel, TextField} from "@mui/material";
import Badge2 from "../../../res/img/badge_2.png";
import GPayButton from "../../../res/img/gpay-button.svg";
import FavoriteIcon from '@mui/icons-material/Favorite';
import moment from "moment";
import * as Sentry from "@sentry/react";
import Skeleton from '@mui/material/Skeleton';
import {Alert} from '@mui/material';
import {UserLocalStorage} from "../../../core/storage/UserLocalStorage";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BuildIcon from '@mui/icons-material/Build';
import StorageIcon from '@mui/icons-material/Storage';
import CoffeeIcon from '@mui/icons-material/Coffee';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class DonationDialog extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			isDonationsLoading: true,
			donations: [],
			supporterDisplayName: '',
			isProductsLoading: false,
			products: [],
			paymentErrorMessage: null,
			paymentWarningMessage: null,
			paymentSuccessMessage: null,
			checkedProductId: 'supporter_badge_1_new',
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.state.isOpen !== Boolean(nextProps.isOpen)) {
			this.setState({
				isOpen: Boolean(nextProps.isOpen),
				supporterDisplayName: this.context.user.name ?? '',
				paymentErrorMessage: null,
				paymentWarningMessage: null,
				paymentSuccessMessage: null,
			});

			if (nextProps.isOpen) {
				this.refresh();
			}
		}
	}

	refresh = () => {
		this.setState({
			paymentErrorMessage: null,
			paymentWarningMessage: null,
			paymentSuccessMessage: null,
		});
		this.fetchPurchaseProducts();
		this.fetchDonationsList();
	}

	resolveDisplayName = () => {
		if (UserLocalStorage.get('paymentDisplayName')) {
			return UserLocalStorage.get('paymentDisplayName');
		} else if (this.state.supporterDisplayName) {
			return this.state.supporterDisplayName;
		}
		return this.context.user.name;
	}

	attemptPurchaseAcknowledgment = async (productName, purchaseToken) => {
		let isSuccess = await fetch(UrlBuilder.playPayments.acknowledge(productName, purchaseToken, this.resolveDisplayName()), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		}).then(response => response.status === 200)
			.catch(res => { return false; })

		if (isSuccess) {
			let user = await fetch(UrlBuilder.user.currentUserApi())
				.then(response => response.status === 200 ? response.json() : null)
				.catch(res => { return null; });

			this.context.setUser(user);
			this.refresh();
			UserLocalStorage.remove('paymentDisplayName');
			return true;
		}

		return false;
	}

	fetchDonationsList = async () => {
		this.setState({ isDonationsLoading: true });

		await fetch(UrlBuilder.donations.donationsApi())
			.then(response => response.json())
			.then(response => {
				this.setState({
					isDonationsLoading: false,
					donations: response['data'] ?? [],
				});
			});
	}

	fetchPurchaseProducts = async () => {
		if ('getDigitalGoodsService' in window) {
			let service;
			try {
				service = await window.getDigitalGoodsService('https://play.google.com/billing');
			} catch (e) {
				Sentry.captureException(e);
				return;
			}

			if (service) {
				this.setState({ isProductsLoading: true });

				let products = [];

				const fetchedProducts = await service.getDetails(['supporter_badge_1_new', 'supporter_badge_2', 'supporter_subscription', 'supporter_subscription_2']).catch(e => {
					Sentry.captureException(e);
					return [];
				});

				fetchedProducts.forEach(product => {
					const localizedPrice = new Intl.NumberFormat(
						navigator.language,
						{style: 'currency', currency: product.price.currency}
					).format(product.price.value);

					products.push({
						id: product.itemId,
						title: product.title,
						price: localizedPrice,
						description: product.description,
					});
				});

				this.setState({
					isProductsLoading: false,
					products: products,
				});
			}
		}
	}

	attemptPayment = async (productName = null) => {
		if (this.state.supporterDisplayName.trim() === '') {
			this.setState({ supporterDisplayNameIsEmpty: true });
			return;
		}

		productName = productName ?? 'supporter_badge_1_new';

		const paymentMethodData = [{
			supportedMethods: 'https://play.google.com/billing',
			data: { sku: productName },
		}];

		const paymentDetails = {
			total: {
				label: `Total`,
				amount: {currency: `USD`, value: `0`}
			}
		};

		const request = new PaymentRequest(paymentMethodData, paymentDetails);

		let paymentMade = false;

		try {
			Sentry.captureMessage("1 - Payment showing initiated for " + this.context.user.email);
			const paymentResponse = await request.show();
			Sentry.captureMessage("2 - Payment response obtained for " + this.context.user.email);

			const {token: purchaseToken} = paymentResponse.details;

			Sentry.captureMessage("3 - Payment made for " + this.context.user.email + " with token: " + purchaseToken, {
				extra: { response: JSON.stringify(paymentResponse) }
			});

			paymentMade = true;

			const isAcknowledgmentSuccess = await this.attemptPurchaseAcknowledgment(productName, purchaseToken);

			if (isAcknowledgmentSuccess) {
				Sentry.captureMessage("4 - Payment acknowledged for " + this.context.user.email + " with token: " + purchaseToken);
				const paymentComplete = await paymentResponse.complete('success');
				Sentry.captureMessage("5 - Payment response completed for " + this.context.user.email);

				this.setState({
					paymentSuccessMessage: "Donation successfully made. Thank you!",
					paymentWarningMessage: null,
					paymentErrorMessage: null,
				});
				return;
			} else {
				Sentry.captureMessage("4 - Payment acknowledged failed for " + this.context.user.email + " with token: " + purchaseToken);
				const paymentComplete = await paymentResponse.complete('fail');
			}
		} catch(e) {
			Sentry.captureMessage(`${e.name}: ${e.message}`);
			try { await request.abort(); } catch (e) {}
		}

		if (paymentMade) {
			this.setState({
				paymentSuccessMessage: null,
				paymentWarningMessage: "Your payment was made but is still being processed by Google Play. Please re-open the app in a few moments and your Supporter's Badge should be ready. If you have any questions please contact us at myworkinprogress.app@gmail.com or leave a feedback message.",
				paymentErrorMessage: null,
			});
			UserLocalStorage.set('paymentDisplayName', this.state.supporterDisplayName);
		} else {
			this.setState({
				paymentSuccessMessage: null,
				paymentWarningMessage: null,
				paymentErrorMessage: "Your payment failed. Please try again. If you have any questions please contact us at myworkinprogress.app@gmail.com or leave a feedback message.",
			});
		}
	}

	updateSupporterNameText = (event) => {
		this.setState({
			supporterDisplayName: event.target.value,
			supporterDisplayNameIsEmpty: false,
		});
	}

	handleCheckboxChange = (event, value) => {
		this.setState({ checkedProductId: value });
	};

	renderDonationOption = (product, isSelected) => (
		<Box
			key={product.id}
			onClick={() => this.handleCheckboxChange(null, product.id)}
			sx={{
				border: '1.5px solid',
				borderColor: isSelected ? 'secondary.main' : 'divider',
				borderRadius: 2,
				p: 1.5,
				cursor: 'pointer',
				transition: 'all 0.15s',
				bgcolor: isSelected
					? (theme) => theme.palette.mode === 'dark' ? 'rgba(245,0,87,0.06)' : 'rgba(245,0,87,0.03)'
					: 'transparent',
				'&:hover': {
					borderColor: isSelected ? 'secondary.main' : 'text.disabled',
				},
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<Checkbox
					checked={isSelected}
					color="secondary"
					size="small"
					sx={{ p: 0 }}
				/>
				<Box sx={{ flex: 1 }}>
					<Typography variant="body2" sx={{ fontWeight: 600 }}>
						{product.label}
					</Typography>
				</Box>
				<Typography variant="body2" sx={{ fontWeight: 700, color: isSelected ? 'secondary.main' : 'text.primary' }}>
					{product.price}
				</Typography>
			</Box>
		</Box>
	)

	renderWhyItMattersRow = (icon, text) => (
		<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 0.5 }}>
			{React.cloneElement(icon, { sx: { fontSize: 18, color: 'secondary.main', mt: 0.2, flexShrink: 0 } })}
			<Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
				{text}
			</Typography>
		</Box>
	)

	render() {
		const isSupporter = this.context.user.isSupporter;

		const donationOptions = [];
		if (this.state.products[0]) {
			donationOptions.push({ id: 'supporter_badge_1_new', label: 'One-time donation', price: this.state.products[0].price });
		}
		if (this.state.products[1]) {
			donationOptions.push({ id: 'supporter_badge_2', label: 'Generous one-time donation', price: this.state.products[1].price });
		}
		if (this.state.products[2]) {
			donationOptions.push({ id: 'supporter_subscription', label: 'Monthly support', price: this.state.products[2].price + '/mo' });
		}
		if (this.state.products[3]) {
			donationOptions.push({ id: 'supporter_subscription_2', label: 'Generous monthly support', price: this.state.products[3].price + '/mo' });
		}

		return (
			<Drawer
				anchor="right"
				open={this.state.isOpen}
				onClose={this.props.closeSelfFunc}
				PaperProps={{
					sx: { width: '90vw', maxWidth: '90vw' },
				}}
				TransitionComponent={Transition}
			>
				<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{/* Header */}
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, pt: 2.5, pb: 1 }}>
						<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 20 }}>
							Support the App
						</Typography>
						<IconButton onClick={this.props.closeSelfFunc} size="small">
							<CloseIcon fontSize="small" />
						</IconButton>
					</Box>

					{/* Content */}
					<Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, pb: 3 }}>

						{/* Supporter badge showcase */}
						{isSupporter && (
							<Box sx={{
								textAlign: 'center', py: 3, mb: 2.5,
								background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main}12 0%, ${theme.palette.secondary.main}25 100%)`,
								borderRadius: 2.5,
							}}>
								<img src={Badge2} alt="Supporter Badge" width={120} style={{ marginBottom: 12 }} />
								<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 20 }}>
									You're a Supporter!
								</Typography>
								<Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
									Thank you for believing in this project.
								</Typography>
							</Box>
						)}

						{/* Personal appeal */}
						<Box sx={{
							bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
							borderRadius: 2.5, p: 2.5, mb: 2.5,
						}}>
							<Typography variant="body2" sx={{ lineHeight: 1.7, color: 'text.secondary' }}>
								This app is built and maintained by a single developer. There's no company behind it, no investors, no ads. Every feature you use was built in free time, fuelled by coffee and a genuine love for lifting.
							</Typography>
							<Typography variant="body2" sx={{ lineHeight: 1.7, color: 'text.secondary', mt: 1.5 }}>
								{isSupporter
									? 'Your support means the world. If you want to donate again, you can pick an option below.'
									: 'Your donation — no matter how small — directly funds server costs and motivates continued development.'
								}
							</Typography>
						</Box>

						{/* Why it matters */}
						<Box sx={{ mb: 2.5 }}>
							<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1.5 }}>
								Where your support goes
							</Typography>
							{this.renderWhyItMattersRow(<StorageIcon />, 'Keeps the servers running 24/7 so your data is always safe')}
							{this.renderWhyItMattersRow(<BuildIcon />, 'Funds new features, bug fixes, and performance improvements')}
							{this.renderWhyItMattersRow(<CoffeeIcon />, 'Fuels the developer behind every line of code')}
						</Box>

						{/* What you get */}
						{!isSupporter && (
							<Box sx={{
								border: '1px solid',
								borderColor: (theme) => `${theme.palette.secondary.main}40`,
								borderRadius: 2.5, p: 2.5, mb: 2.5,
								background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main}08 0%, ${theme.palette.secondary.main}18 100%)`,
							}}>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
									<EmojiEventsIcon sx={{ color: 'secondary.main', fontSize: 22 }} />
									<Typography variant="body2" sx={{ fontWeight: 700 }}>
										What you get
									</Typography>
								</Box>
								<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, pl: 0.5 }}>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
										<img src={Badge2} alt="Badge" width={28} />
										<Typography variant="body2" sx={{ color: 'text.secondary' }}>
											An exclusive <strong>Supporter's Badge</strong> on your profile
										</Typography>
									</Box>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
										<FavoriteIcon sx={{ fontSize: 20, color: 'error.main', ml: 0.5 }} />
										<Typography variant="body2" sx={{ color: 'text.secondary' }}>
											Your name on the <strong>Supporters List</strong> below
										</Typography>
									</Box>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
										<VolunteerActivismIcon sx={{ fontSize: 20, color: 'secondary.main', ml: 0.5 }} />
										<Typography variant="body2" sx={{ color: 'text.secondary' }}>
											The satisfaction of keeping a passion project alive
										</Typography>
									</Box>
								</Box>
							</Box>
						)}

						{/* Donation options */}
						{this.state.isProductsLoading ? (
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
								<Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
								<Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
								<Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
							</Box>
						) : ('getDigitalGoodsService' in window && donationOptions.length > 0) ? (
							<Box>
								<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1.5 }}>
									Choose an amount
								</Typography>

								<TextField
									variant="outlined"
									label="Your name on the Supporters List"
									defaultValue={this.state.supporterDisplayName}
									onChange={this.updateSupporterNameText}
									error={this.state.supporterDisplayNameIsEmpty}
									helperText={this.state.supporterDisplayNameIsEmpty ? 'Name is required' : null}
									fullWidth
									size="small"
									sx={{ mb: 2 }}
								/>

								<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
									{donationOptions.map(opt => this.renderDonationOption(opt, this.state.checkedProductId === opt.id))}
								</Box>

								<Box sx={{ display: 'flex', justifyContent: 'center', mt: 2.5 }}>
									<img
										src={GPayButton}
										alt="Donate with Google Play"
										width={215}
										style={{ cursor: 'pointer' }}
										onClick={() => this.attemptPayment(this.state.checkedProductId)}
									/>
								</Box>

								<Typography variant="caption" sx={{ color: 'text.disabled', display: 'block', textAlign: 'center', mt: 1 }}>
									Secure payment through Google Play. Subscriptions can be cancelled anytime.
								</Typography>
							</Box>
						) : (
							<Box sx={{
								bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
								borderRadius: 2, px: 2, py: 1.5, textAlign: 'center',
							}}>
								<Typography variant="body2" sx={{ color: 'text.secondary' }}>
									Donations are available through the Google Play app.
								</Typography>
							</Box>
						)}

						{/* Alerts */}
						{this.state.paymentErrorMessage && (
							<Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentErrorMessage}</Alert>
						)}
						{this.state.paymentWarningMessage && (
							<Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentWarningMessage}</Alert>
						)}
						{this.state.paymentSuccessMessage && (
							<Alert severity="success" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentSuccessMessage}</Alert>
						)}

						{/* Supporters List */}
						<Box sx={{
							mt: 3, pt: 2.5,
							borderTop: '1px solid',
							borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
						}}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
								<FavoriteIcon sx={{ fontSize: 18, color: 'error.main' }} />
								<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 17 }}>
									Supporters List
								</Typography>
							</Box>

							{this.state.isDonationsLoading ? (
								<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
									{[1, 2, 3].map(i => (
										<Skeleton key={i} variant="rounded" height={44} sx={{ borderRadius: 1.5 }} />
									))}
								</Box>
							) : this.state.donations.length === 0 ? (
								<Box sx={{
									textAlign: 'center', py: 3,
									bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
									borderRadius: 2,
								}}>
									<FavoriteIcon sx={{ fontSize: 28, color: 'text.disabled', mb: 0.5 }} />
									<Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
										No supporters yet
									</Typography>
									<Typography variant="caption" sx={{ color: 'text.disabled' }}>
										Be the first one!
									</Typography>
								</Box>
							) : (
								<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
									{this.state.donations.map((supporter, index) => (
										<Box
											key={supporter.displayName + index}
											sx={{
												display: 'flex', alignItems: 'center', gap: 1.5,
												px: 2, py: 1.25, borderRadius: 1.5,
												bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
											}}
										>
											<FavoriteIcon sx={{ fontSize: 16, color: 'error.main', flexShrink: 0 }} />
											<Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
												{supporter.displayName}
											</Typography>
											<Typography variant="caption" sx={{ color: 'text.disabled' }}>
												{moment(supporter.dateCreated).format('MMM YYYY')}
											</Typography>
										</Box>
									))}
								</Box>
							)}
						</Box>
					</Box>

					{/* Close button */}
					<Box sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
						<Button
							fullWidth
							variant="outlined"
							onClick={this.props.closeSelfFunc}
							sx={{ textTransform: 'none', fontWeight: 500 }}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Drawer>
		);
	}
}

DonationDialog.contextType = UserContext;

export default DonationDialog;
